import { z } from 'zod';

export const messageFormSchema = z.object({
  content: z.string(),
  transcript: z.string().optional(),
});

export type MessageFormValues = z.infer<typeof messageFormSchema>;

export interface SubmitMessageOptions {
  /**
   * When true, the voice session is kept active after the message is sent
   * (hands-free "next" voice command). A manual Continue/Send submit leaves
   * this unset so the recording session ends.
   */
  keepListening?: boolean;
}

export type ActivityStore = {
  lastContentUpdateAt: number | null;
  /**
   * Call from consumers to record a fresh "content update" timestamp without
   * mutating the ref-object property directly (which the
   * react-hooks/immutability rule flags when the ref is a prop).
   */
  notifyContentUpdate: () => void;
};
